import { buildAdminPath, getAdminLoginPath } from './adminPath'
import { resolveSectionFromLocation } from './sectionRouting'

export const LOGIN_PATH = getAdminLoginPath()
export const LOGIN_PATH_REGEX = /^\/login\/?$/
export const REDIRECT_QUERY_PARAM = 'redirect'
export const ONBOARDING_QUERY_PARAM = 'onboarding'

export type OnboardingQueryValue = 'setup' | 'login'

export const normalizeOnboardingQueryValue = (value: string | null): OnboardingQueryValue | null => {
  if (value === 'setup' || value === 'login') return value
  return null
}

export const normalizeRedirectTarget = (value: string | null, currentOrigin: string): string | null => {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed || !trimmed.startsWith('/') || trimmed.startsWith('//')) return null

  try {
    const parsed = new URL(trimmed, currentOrigin)
    if (parsed.origin !== currentOrigin) return null
    if (/^\/dashboard(?:\/|$)/.test(parsed.pathname)) {
      const dashboardSuffix = parsed.pathname.replace(/^\/dashboard(?=\/|$)/, '')
      parsed.pathname = buildAdminPath(dashboardSuffix || '/')
    }
    if (!resolveSectionFromLocation(parsed.search, parsed.hash, parsed.pathname) && !LOGIN_PATH_REGEX.test(parsed.pathname)) {
      return null
    }
    if (LOGIN_PATH_REGEX.test(parsed.pathname)) return null
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}
